import { useEffect, useRef} from "react";
import { useContext } from "react";
import { MessageContext } from "../store/messageStore";
import { Toast } from "primereact/toast";

// https://smartdevpreneur.com/using-and-styling-the-material-ui-alert-component/  //可參考此篇如何修改Alert內容樣式

function Message() {
  // const [message, setMessage] = useState({})
  const [message] = useContext(MessageContext);
  const toast = useRef(null);

useEffect(() => {
  if (message?.title) {
    toast.current.show({
      severity: message.type,
      // summary: 'Success',
      detail: message?.title, 
      life: 3000     
    });
  }
}, [message.title]); 

  return (
    <>
        {message.title && (
            <Toast ref={toast} />
        )}
   

   

        

    </>
  );
}

export default Message;
